import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { runSaga } from 'redux-saga';
import { PayerOnboardingViewModel } from './payer-onboarding-generated';
import { configure } from 'mobx';
import { AjaxUtils } from '../Shared/utils/ajax-utils';
import '../WebGiving/utils/hover-on-touch-fix';
import { PayerOnboardingMain } from './main/payer-onboarding-main';
import { scrollToTopOnRefresh } from '../Shared/utils/scroll-to-top';
import { GoogleAnalyticsWrapper } from '../WebGiving/infrastructure/google-analytics-wrapper';
import { PayerOnboardingSagaContext } from './payer-onboarding-saga-context';
import { payerOnboardingSaga } from './payer-onboarding-saga';
import { recordPageStats } from './payer-onboarding-page-stats-recorder';

configure({ enforceActions: true });
let disableValidation = false;

function initApp(model: PayerOnboardingViewModel) {
	GoogleAnalyticsWrapper.initialize('PayerOnboarding');

	scrollToTopOnRefresh();

	const sagaContext = new PayerOnboardingSagaContext(model, disableValidation);
	runSaga({}, (context) => payerOnboardingSaga(context), sagaContext);
	recordPageStats(sagaContext);

	ReactDOM.render(React.createElement(PayerOnboardingMain, { vm: sagaContext.mainViewModel }), document.getElementById('react-container'));
}

export function init(model: string) {
	initApp(parseModelJSON(model));
}

function parseModelJSON(model: string): PayerOnboardingViewModel {
	return JSON.parse(model, AjaxUtils.reviveDate);
}
